export interface Gallery {
  id: number;
  linkUrl: string;
  image: string;
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyGallery = (): Gallery => ({
  id: 0,
  linkUrl: '',
  image: '',
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const galleryFromResponse = (responseData: any): Gallery => ({
  id: responseData.id,
  linkUrl: responseData.link_url,
  image: responseData.image_path,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const galleryToUpsertRequest = (gallery: Gallery) => ({
  link_url: gallery.linkUrl,
});
